/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlightModificationPolicy } from './FlightModificationPolicy';
import {
    FlightModificationPolicyFromJSON,
    FlightModificationPolicyFromJSONTyped,
    FlightModificationPolicyToJSON,
    FlightModificationPolicyToJSONTyped,
} from './FlightModificationPolicy';

/**
 *
 * @export
 * @interface FlightObservedFare
 */
export interface FlightObservedFare {
    /**
     *
     * @type {string}
     * @memberof FlightObservedFare
     */
    cabin?: string | null;
    /**
     *
     * @type {string}
     * @memberof FlightObservedFare
     */
    fareBrand?: string | null;
    /**
     *
     * @type {string}
     * @memberof FlightObservedFare
     */
    connectionProtection?: FlightObservedFareConnectionProtectionEnum | null;
    /**
     *
     * @type {FlightModificationPolicy}
     * @memberof FlightObservedFare
     */
    changeBeforeDeparture?: FlightModificationPolicy | null;
    /**
     *
     * @type {FlightModificationPolicy}
     * @memberof FlightObservedFare
     */
    refundBeforeDeparture?: FlightModificationPolicy | null;
}


/**
 * @export
 */
export const FlightObservedFareConnectionProtectionEnum = {
    Protected: 'protected',
    SelfTransfer: 'self_transfer'
} as const;
export type FlightObservedFareConnectionProtectionEnum = typeof FlightObservedFareConnectionProtectionEnum[keyof typeof FlightObservedFareConnectionProtectionEnum];


/**
 * Check if a given object implements the FlightObservedFare interface.
 */
export function instanceOfFlightObservedFare(value: object): value is FlightObservedFare {
    return true;
}

export function FlightObservedFareFromJSON(json: any): FlightObservedFare {
    return FlightObservedFareFromJSONTyped(json, false);
}

export function FlightObservedFareFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightObservedFare {
    if (json == null) {
        return json;
    }
    return {

        'cabin': json['cabin'] == null ? undefined : json['cabin'],
        'fareBrand': json['fare_brand'] == null ? undefined : json['fare_brand'],
        'connectionProtection': json['connection_protection'] == null ? undefined : json['connection_protection'],
        'changeBeforeDeparture': json['change_before_departure'] == null ? undefined : FlightModificationPolicyFromJSON(json['change_before_departure']),
        'refundBeforeDeparture': json['refund_before_departure'] == null ? undefined : FlightModificationPolicyFromJSON(json['refund_before_departure']),
    };
}

export function FlightObservedFareToJSON(json: any): FlightObservedFare {
    return FlightObservedFareToJSONTyped(json, false);
}

export function FlightObservedFareToJSONTyped(value?: FlightObservedFare | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'cabin': value['cabin'],
        'fare_brand': value['fareBrand'],
        'connection_protection': value['connectionProtection'],
        'change_before_departure': FlightModificationPolicyToJSON(value['changeBeforeDeparture']),
        'refund_before_departure': FlightModificationPolicyToJSON(value['refundBeforeDeparture']),
    };
}
